import { render, staticRenderFns } from "./QueryOS.vue?vue&type=template&id=2b5db295&scoped=true&"
import script from "./QueryOS.vue?vue&type=script&lang=js&"
export * from "./QueryOS.vue?vue&type=script&lang=js&"
import style0 from "./QueryOS.vue?vue&type=style&index=0&id=2b5db295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5db295",
  null
  
)

export default component.exports